export const menus = [
	{ is_header: true, title: "Navegación Principal" },
	{ path: "/dashboard", icon: "bi bi-house", title: "Inicio" },
	{ path: "/users", icon: "bi bi-person", title: "Usuarios" },
	{ path: "/events", icon: "bi bi-calendar", title: "Eventos" },
];
